export default "__VITE_ASSET__2J6i4F34__"